import * as yup from "yup";

export const timesOptions = [5, 10, 15, 20, 25, 30];

const kafdClientId = process.env.REACT_APP_KAFD_CLIENT_ID;

export const schema = yup.object().shape({
  //basic info
  mode: yup
    .string()
    .required("Required")
    .oneOf(["add", "edit"] as const),
  clientId: yup.string().when("mode", {
    is: "add",
    then: (value) => value.required("Required"),
  }),
  type: yup
    .string()
    .required("Required")
    .oneOf(["regular", "event"] as const),
  area: yup.number().when("clientId", {
    is: kafdClientId,
    then: (value) => value.typeError("Required").required("Required"),
  }),
  category: yup.string().when("clientId", {
    is: kafdClientId,
    then: (value) => value.required("Required"),
  }),
  dropOffName: yup.string().when("clientId", {
    is: kafdClientId,
    then: (value) => value.required("Required"),
  }),
  parkingParcels: yup.array().of(
    yup.object().shape({
      name: yup
        .string()
        .test("required-if-client", "Required", function (value) {
          const parent = this.from?.[1]?.value; // root form object
          const clientId = parent?.clientId;
          if (clientId === kafdClientId) {
            return !!value;
          }
          return true;
        }),
    }),
  ),
  isKafdReport: yup.boolean().required("Required"),
  isKafdPreBooking: yup.boolean().required("Required"),
  nameEn: yup.string().trim().required("Required"),
  nameAr: yup.string().trim(),
  //address
  cityId: yup.string().required("Required"),
  shippingAddress: yup.string().trim().required("Required"),
  shippingBuildingNumber: yup.string().trim().required("Required"),
  shippingState: yup.string().trim().required("Required"),
  shippingZip: yup
    .string()
    .required("Required")
    .test(
      "is-5-digits",
      "Invalid Saudi postal code (must be 5 digits)",
      (value) => {
        if (value === undefined || value === null) return false;
        return /^\d{5}$/.test(String(value));
      },
    ),
  shippingCountry: yup.string().required("Required"),
  //gates
  gates: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().trim().required("Required"),
      }),
    )
    .required("Required"),

  times: yup.array().of(yup.number().required()).required().min(1, "Required"),
  totalParkingSpaces: yup
    .number()
    .typeError("Required")
    // .positive("Must be a positive number")
    .min(0, "Must be a positive number or zero")
    .required("Required"),
  valetParkingSpaces: yup
    .number()
    .typeError("Required")
    .min(0, "Must be a positive number or zero")
    .required("Required"),
  selfParkingSpaces: yup
    .number()
    .typeError("Required")
    .min(0, "Must be a positive number or zero")
    .required("Required"),
});

export interface FormInputs extends yup.InferType<typeof schema> {}
